import { useState } from "react";

function FacebookIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="-204.79995 -341.33325 1774.9329 2047.9995">
      <path d="M1365.333 682.667C1365.333 305.64 1059.693 0 682.667 0 305.64 0 0 305.64 0 682.667c0 340.738 249.641 623.16 576 674.373V880H402.667V682.667H576v-150.4c0-171.094 101.917-265.6 257.853-265.6 74.69 0 152.814 13.333 152.814 13.333v168h-86.083c-84.804 0-111.25 52.623-111.25 106.61v128.057h189.333L948.4 880H789.333v477.04c326.359-51.213 576-333.635 576-674.373" fill="#455a64" /><path d="M948.4 880l30.267-197.333H789.333V554.609C789.333 500.623 815.78 448 900.584 448h86.083V280s-78.124-13.333-152.814-13.333c-155.936 0-257.853 94.506-257.853 265.6v150.4H402.667V880H576v477.04a687.805 687.805 0 00106.667 8.293c36.288 0 71.91-2.84 106.666-8.293V880H948.4" fill="#fff" />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="-83.77245 -140.29175 726.0279 841.7505">
      <path d="M407.185 336.283c-6.948-3.478-41.108-20.284-47.477-22.606-6.368-2.318-11-3.476-15.632 3.478-4.632 6.954-17.948 22.606-22.001 27.244-4.052 4.636-8.106 5.218-15.054 1.738-6.948-3.477-29.336-10.813-55.874-34.486-20.655-18.424-34.6-41.176-38.652-48.132-4.054-6.956-.434-10.716 3.045-14.18 3.127-3.114 6.95-8.116 10.423-12.174 3.474-4.056 4.632-6.956 6.948-11.59 2.316-4.639 1.158-8.695-.58-12.172-1.736-3.478-15.632-37.679-21.422-51.592-5.64-13.547-11.368-11.712-15.633-11.927-4.048-.201-8.685-.244-13.316-.244-4.632 0-12.16 1.739-18.53 8.693-6.367 6.956-24.317 23.767-24.317 57.964 0 34.202 24.896 67.239 28.371 71.876 3.475 4.639 48.993 74.818 118.695 104.914 16.576 7.16 29.518 11.434 39.609 14.636 16.644 5.289 31.79 4.542 43.763 2.753 13.349-1.993 41.108-16.807 46.898-33.036 5.79-16.233 5.79-30.144 4.052-33.041-1.736-2.899-6.368-4.638-13.316-8.116m-126.776 173.1h-.093c-41.473-.016-82.15-11.159-117.636-32.216l-8.44-5.01-87.475 22.947 23.348-85.288-5.494-8.745c-23.136-36.798-35.356-79.328-35.338-123 .051-127.431 103.734-231.106 231.22-231.106 61.734.022 119.763 24.094 163.402 67.782 43.636 43.685 67.653 101.754 67.629 163.51-.052 127.442-103.733 231.126-231.123 231.126M477.113 81.55C424.613 28.989 354.795.03 280.407 0 127.136 0 2.392 124.736 2.33 278.053c-.02 49.011 12.784 96.847 37.118 139.019L0 561.167l147.41-38.668c40.617 22.153 86.346 33.83 132.886 33.845h.115c153.254 0 278.009-124.748 278.072-278.068.028-74.301-28.87-144.165-81.37-196.725" fill="#455a64" fill-rule="evenodd" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="-100.7682 -167.947 873.3244 1007.682">
      <g fill="#455a64">
        <path d="M335.895 0c-91.224 0-102.663.387-138.49 2.021-35.752 1.631-60.169 7.31-81.535 15.612-22.088 8.584-40.82 20.07-59.493 38.743-18.674 18.673-30.16 37.407-38.743 59.495C9.33 137.236 3.653 161.653 2.02 197.405.386 233.232 0 244.671 0 335.895c0 91.222.386 102.661 2.02 138.488 1.633 35.752 7.31 60.169 15.614 81.534 8.584 22.088 20.07 40.82 38.743 59.495 18.674 18.673 37.405 30.159 59.493 38.743 21.366 8.302 45.783 13.98 81.535 15.612 35.827 1.634 47.266 2.021 138.49 2.021 91.222 0 102.661-.387 138.488-2.021 35.752-1.631 60.169-7.31 81.534-15.612 22.088-8.584 40.82-20.07 59.495-38.743 18.673-18.675 30.159-37.407 38.743-59.495 8.302-21.365 13.981-45.782 15.612-81.534 1.634-35.827 2.021-47.266 2.021-138.488 0-91.224-.387-102.663-2.021-138.49-1.631-35.752-7.31-60.169-15.612-81.534-8.584-22.088-20.07-40.822-38.743-59.495-18.675-18.673-37.407-30.159-59.495-38.743-21.365-8.302-45.782-13.981-81.534-15.612C438.556.387 427.117 0 335.895 0zm0 60.521c89.686 0 100.31.343 135.729 1.959 32.75 1.493 50.535 6.965 62.37 11.565 15.68 6.094 26.869 13.372 38.622 25.126 11.755 11.754 19.033 22.944 25.127 38.622 4.6 11.836 10.072 29.622 11.565 62.371 1.616 35.419 1.959 46.043 1.959 135.73 0 89.687-.343 100.311-1.959 135.73-1.493 32.75-6.965 50.535-11.565 62.37-6.094 15.68-13.372 26.869-25.127 38.622-11.753 11.755-22.943 19.033-38.621 25.127-11.836 4.6-29.622 10.072-62.371 11.565-35.413 1.616-46.036 1.959-135.73 1.959-89.694 0-100.315-.343-135.73-1.96-32.75-1.492-50.535-6.964-62.37-11.564-15.68-6.094-26.869-13.372-38.622-25.127-11.754-11.753-19.033-22.943-25.127-38.621-4.6-11.836-10.071-29.622-11.565-62.371-1.616-35.419-1.959-46.043-1.959-135.73 0-89.687.343-100.311 1.959-135.73 1.494-32.75 6.965-50.535 11.565-62.37 6.094-15.68 13.373-26.869 25.126-38.622 11.754-11.755 22.944-19.033 38.622-25.127 11.836-4.6 29.622-10.072 62.371-11.565 35.419-1.616 46.043-1.959 135.73-1.959" /><path d="M335.895 447.859c-61.838 0-111.966-50.128-111.966-111.964 0-61.838 50.128-111.966 111.966-111.966 61.836 0 111.964 50.128 111.964 111.966 0 61.836-50.128 111.964-111.964 111.964zm0-284.451c-95.263 0-172.487 77.224-172.487 172.487 0 95.261 77.224 172.485 172.487 172.485 95.261 0 172.485-77.224 172.485-172.485 0-95.263-77.224-172.487-172.485-172.487m219.608-6.815c0 22.262-18.047 40.307-40.308 40.307-22.26 0-40.307-18.045-40.307-40.307 0-22.261 18.047-40.308 40.307-40.308 22.261 0 40.308 18.047 40.308 40.308" />
      </g>
    </svg>
    // <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
    //   <defs>
    //     <linearGradient id="share-ig-grad" x1="0" y1="1" x2="1" y2="0">
    //       <stop offset="0%" stopColor="#FEDA75" />
    //       <stop offset="35%" stopColor="#D62976" />
    //       <stop offset="70%" stopColor="#962FBF" />
    //       <stop offset="100%" stopColor="#4F5BD5" />
    //     </linearGradient>
    //   </defs>
    //   <rect width="24" height="24" rx="6" fill="url(#share-ig-grad)" />
    //   <rect x="6" y="6" width="12" height="12" rx="4" fill="none" stroke="#fff" strokeWidth="1.6" />
    //   <circle cx="12" cy="12" r="3.2" fill="none" stroke="#fff" strokeWidth="1.6" />
    //   <circle cx="16.2" cy="7.8" r="1" fill="#fff" />
    // </svg>
  );
}

function stripHtml(html) {
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export default function ShareButtons({ athlete }) {
  const [useOwnText, setUseOwnText] = useState(true);
  const [copied, setCopied] = useState(false);

  const profileUrl = `${process.env.REACT_APP_FRONTEND_URL}/deelnemers/${athlete.slug || athlete._id}`;
  const ownText = stripHtml(athlete.bio || "");
  const shareText = useOwnText && ownText ? ownText : "Steun mij bij de Hartekind actie 2026!";
  const fullMessage = `${shareText}\n\n${profileUrl}`;

  const shareFacebook = () => {
    copyFullMessageToClipboard(fullMessage, setCopied);

    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(profileUrl)}&quote=${encodeURIComponent(shareText)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const shareWhatsapp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(fullMessage)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const shareInstagram = () => {
    copyFullMessageToClipboard(fullMessage, setCopied);
  };

  return (
    <div className="ob-section-card">
      <div className="ob-section-header">
        <span className="ob-section-title">Deel je pagina</span>
      </div>
      <div className="ob-section-body">
        <p>Deel je eigen deelnemerspagina met vrienden, familie en collega's.</p>
        <label className="onboarding-check">
          <input
            type="checkbox"
            checked={useOwnText}
            onChange={e => setUseOwnText(e.target.checked)}
            style={{ display: "inline", width: "auto", margin: 0 }}
          />
          Gebruik mijn profieltekst in het gedeelde bericht
        </label>
        <p className="note">
          <strong>Let op!</strong> Het is niet mogelijk om een Signal- of Instagram-post te genereren vanuit deze website,
          maar wel om de link naar je pagina + je profieltekst te kopiëren.
        </p>
        <p className="note">
          Er wordt een tekst met de link gegeneerd en gekopieerd naar je klembord als je op de Instagram-knop klikt. Plak deze vervolgens in de betreffende app.
        </p>
        <div className="share-buttons">
          <button type="button" className="share-btn" onClick={shareFacebook}>
            <FacebookIcon />
            <span>Facebook</span>
          </button>
          <button type="button" className="share-btn" onClick={shareWhatsapp}>
            <WhatsAppIcon />
            <span>WhatsApp</span>
          </button>
          <button type="button" className="share-btn" onClick={shareInstagram}>
            <InstagramIcon />
            <span>Instagram</span>
          </button>
        </div>
        {copied && (
          <p className="note" style={{ marginTop: "0.5rem" }}>
            Tekst en link gekopieerd naar je klembord! Plak dit waar je je pagina wilt delen - als de tekst daar niet automatisch wordt ingevuld.
          </p>
        )}
      </div>
    </div>
  );
}
async function copyFullMessageToClipboard(fullMessage, setCopied) {
  try {
    await navigator.clipboard.writeText(fullMessage);
    setCopied(true);
    setTimeout(() => setCopied(false), 4000);
  } catch {
    // Klembord-toegang kan ontbreken (bijv. zonder https) — dan gewoon niets tonen.
  }
}

